import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-4 text-center"
};
const _hoisted_2 = {
  class: "text-2xl font-bold"
};
const _hoisted_3 = {
  key: 0,
  class: "border-b px-6 pb-4"
};
const _hoisted_4 = {
  class: "mb-8 -mx-4 px-4"
};
const _hoisted_5 = {
  class: "flex"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionScreen',
  props: {
    full: {
      type: Boolean
    }
  },
  emits: ['finished'],
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(_Teleport, {
        to: "#app-outside",
        disabled: !__props.full
      }, [_createElementVNode("div", {
        class: _normalizeClass(["rounded-xl bg-white w-full", {
          'absolute top-0 left-0 right-0 bottom-0': __props.full
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "title")]), _ctx.$slots.subTitle ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "subTitle")])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default")]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "controls", {}, () => [_createVNode(_component_NButton, {
        type: "success",
        secondary: "",
        block: "",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('finished'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ok')), 1)]),
        _: 1
      })])])], 2)], 8, ["disabled"]);
    };
  }
});